<template>
  <Container>
    <template #header>
      <HeaderFe />
    </template>
    <template v-slot:default>
      <main>
        <section class="pb-10">
          <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <h2 class="mt-8 mb-6 font-semibold text-heading-5 text-dark">
              Pimpinan Jurusan
            </h2>
            <div class="pt-4 border-t border-gray-3">
              <div
                class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-8 gap-x-6 lg:gap-x-8 lg:gap-y-10"
              >
                <!-- Card Item -->
                <div
                  v-for="(author, index) in formasi.data"
                  :key="author.id || index"
                  class="flex flex-col items-center border border-gray-3 rounded-[20px] p-6 lg:p-7 cursor-pointer hover:bg-white hover:drop-shadow-1 hover:-translate-y-2 transition-all gap-2"
                  @click="viewProfile(author.id)"
                >
                  <div
                    class="flex items-center justify-center w-32 h-32 mb-5 overflow-hidden bg-white rounded-full shadow"
                  >
                    <img
                      :src="getFotoUrl(author.dosen.foto)"
                      :alt="author.dosen.nama"
                      class="object-cover w-full h-full"
                    />
                  </div>
                  <h3
                    class="mb-1 text-base font-semibold text-center whitespace-pre-line text-dark mobile-font"
                  >
                    {{ author.dosen.nama }}
                  </h3>
                  <h5
                    class="mb-1 text-base font-semibold text-center whitespace-pre-line text-dark mobile-font"
                  >
                    NIP. {{ author.dosen.nip }}
                  </h5>
                  <p
                    class="text-sm text-center whitespace-pre-line mobile-font"
                  >
                    {{ author.jabatan.namajabatan }}
                  </p>
                </div>
              </div>
            </div>
            <div v-if="isModalOpen">
              <Loading
                v-if="isLoading"
                :active="isLoading"
                :can-cancel="false"
                :is-full-page="false"
              />
              <ProfilDewas
                v-else
                v-model:isOpen="isModalOpen"
                :formasi="viewFormasi"
                :title="`${viewFormasi?.jabatan?.namajabatan}`"
              />
            </div>
          </div>
        </section>
      </main>
    </template>
    <template #footer>
      <FooterFe />
    </template>
  </Container>
</template>
<script setup>
import { defineProps, ref } from "vue";
import Container from "@/Layouts/Container.vue";
import HeaderFe from "@/Components/HeaderFe.vue";
import FooterFe from "@/Components/FooterFe.vue";
import ProfilDewas from "@/Components/Web/ProfilDewas.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

defineProps({
  formasi: {
    type: Object,
    required: true,
  },
});

const isModalOpen = ref(false);
const viewFormasi = ref(null);
const isLoading = ref(false);
function getFotoUrl(foto) {
  if (!foto) return "./images/user/user-01.png";
  if (/^https?:\/\//.test(foto) || foto.startsWith("/storage")) {
    return foto;
  }
  return "/storage/" + foto;
}
const viewProfile = async (id) => {
  isLoading.value = true;
  isModalOpen.value = true;
  viewFormasi.value = null;
  try {
    const response = await fetch(`/pejabat/${id}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      throw new Error("Response is not JSON");
    }
    const data = await response.json();
    viewFormasi.value = data.formasidata;
  } catch (error) {
    console.error("Error fetching data:", error.message);
  } finally {
    isLoading.value = false;
  }
};
</script>

<style scoped>
/* Mobile-specific font styling */
.mobile-font {
  /* Mobile font (default) */
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    sans-serif;
  font-weight: 500;
}

/* Desktop font styling */
@media (min-width: 640px) {
  .mobile-font {
    font-family: "Roboto", "Segoe UI", -apple-system, BlinkMacSystemFont,
      sans-serif;
    font-weight: inherit;
  }
}
</style>
